import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { SubCategoryTable } from "../../UI/SubCategories/SubCategoryTable";

const SubCategories = () => {
  return (
    <div>
      <PanelHead title="SubCategories" />
      <PanelBody content={<SubCategoryTable />} />
    </div>
  );
};

export default SubCategories;
